const DynamiCFormModal = ({id,title,children}) =>{
    return (
        <>
         <dialog id={id} className="modal w-full max-w-lg sm:max-w-2xl  p-2 shadow-md rounded-md">
            <div className="modal-box bg-white">
                <form method="dialog">
                {/* if there is a button in form, it will close the modal */}
                <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                </form>
                <h1 className='text-gray-700 font-medium text-xl text-center'>{title}</h1>
                <div className='mt-4'>  
                    {children} 
                </div>
           </div>
        </dialog>
        </>
    )
}

export default DynamiCFormModal;